import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-superuser-reports-winlose',
  templateUrl: './superuser-reports-winlose.component.html',
  styleUrls: ['./superuser-reports-winlose.component.scss']
})
export class SuperuserReportsWinloseComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
